import * as React from "react";
const SvgFiBrandsConfluence = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-confluence_svg__a)">
      <path d="M.873 18.057c-.254.399-.544.87-.761 1.233a.765.765 0 0 0 .254 1.052l4.966 3.046a.763.763 0 0 0 1.05-.254c.182-.326.436-.762.726-1.233 1.957-3.228 3.95-2.865 7.503-1.161l4.929 2.32c.399.182.834 0 1.015-.362l2.356-5.331c.18-.363 0-.834-.362-1.015a153 153 0 0 1-4.93-2.357c-6.706-3.228-12.397-3.01-16.746 4.062" />
      <path d="M23.127 5.943c.254-.4.544-.87.76-1.233a.765.765 0 0 0-.253-1.052L18.668.61a.763.763 0 0 0-1.051.254 33 33 0 0 1-.725 1.233c-1.957 3.228-3.951 2.865-7.503 1.16L4.46.939a.77.77 0 0 0-1.015.363L1.09 6.63c-.181.364 0 .835.362 1.017a153 153 0 0 1 4.929 2.357c6.706 3.192 12.397 3.01 16.746-4.062" />
    </g>
    <defs>
      <clipPath id="fi-brands-confluence_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsConfluence;
